import { queryOptions, useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { queryKeys } from '@/api/utils/queryKeys';
import { Modal } from '@/components/ModalRenderer/Modal';
import { PortableTextContent } from '@/components/shared';
import { cmsApi } from '@/integrations/sanity/api';

const termsAndConditionsQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.cms.termsAndConditions,
    queryFn: cmsApi.getTermsAndConditions,
    staleTime: Infinity,
  });

const TermsAndConditionsModal = () => {
  const { t } = useTranslation(['Common']);
  const { data: termsAndConditionsData } = useQuery(termsAndConditionsQueryOptions());

  if (!termsAndConditionsData) {
    return null;
  }

  return (
    <Modal title={t('termsAndConditionsFairloEverydayLoans')}>
      <div className="flex flex-col gap-4">
        {termsAndConditionsData?.contentBlockGroup?.contentBlocks?.map(contentBlock => (
          <div key={contentBlock._key}>
            <div className="flex flex-col gap-4">
              <h4 className="text-body-semibold">{contentBlock.title}</h4>
              <div className="space-y-2">
                {!!contentBlock.body && <PortableTextContent value={contentBlock.body} />}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default TermsAndConditionsModal;
